jQuery( function($) {
    $(document).ready( function() {
        $('.my-order').on('click', function() {
            const orderId = $(this).data('order-id');
            const modalId = '#order-details-' + orderId;

            $(modalId).show();

            $(modalId).on('click', '.order-details-close', function() {
                $(modalId).hide();
            });
        });
    });
});